import {
    Box,
    Container,
    Grid,
    Link,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { motion } from 'framer-motion';
import CustomTextButton from '../Common/CustomButton';
import { COLORS } from '../../Constants/styles';
import { ChampionsForge_IMG } from '../../Constants/ImageConstants';
import JoinCommunity from '../Home/JoinCommunity';
import BannerSection from '../Common/BannerSection';

const championsForgebanner = {
    title: 'ChampionsForge',
    description: 'Where Grassroots Dreams Begin',
    image: ChampionsForge_IMG.ChampionsForge2,
};

const newsData = [
    {
        title: 'Gallery Highlights',
        Description: 'Sneak peeks into our training sessions, fun drills, school programs, and sporting events. ',
        date: 'November 8, 2024',
        image: ChampionsForge_IMG.ChampionsForge1,
        link: '/',
    },
    {
        title: 'Blog & Articles ',
        Description: 'Tips from coaches, youth sports insights, training advice, and behind-the-scenes stories.',
        date: 'November 5, 2024',
        image: ChampionsForge_IMG.ChampionsForge2,
        link: '/',
    },
    {
        title: 'Success Stories (Coming Soon) ',
        Description: 'Featuring budding champions, dedicated coaches, and grassroots heroes making an impact. ',
        date: 'November 5, 2024',
        image: ChampionsForge_IMG.ChampionsForge3,
        link: '/',
    },
    {
        title: 'News & Updates ',
        Description: 'Stay informed about new programs, upcoming events, and exciting announcements. ',
        date: 'November 5, 2024',
        image: ChampionsForge_IMG.ChampionsForge4,
        link: '/',
    },
];

const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (i = 1) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.3,
            duration: 0.6,
        },
    }),
};

const ChampionsForgeSection = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <BannerSection data={championsForgebanner} />

            <Box sx={{ px: { xs: 2, md: 1 }, py: 6, bgcolor: COLORS.greyBG, color: COLORS.pureBlack }}>
                <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={1}>
                    <Typography variant="h6" textAlign="center" textTransform="uppercase" fontWeight={700} mb={1} sx={{ mt: 4, color: COLORS.pureBlack }}>
                        Welcome to ChampionsForge
                    </Typography>
                </motion.div>
                <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={2}>
                    <Typography variant="h3" textAlign="center" fontWeight={700} mb={4} sx={{ mt: 4, color: COLORS.pureBlack }}>
                        Where Grassroots Dreams Begin
                    </Typography>
                </motion.div>
                <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={3}>
                    <Typography variant="body2" textAlign="center" mb={2} sx={{ mt: 4, fontSize: '1rem' }}>
                        ChampionsForge is the official spotlight zone of Grassroots Sports Education & Services   dedicated to showcasing the journey, stories, and milestones of young athletes, programs, and communities we serve.
                    </Typography>
                </motion.div>
                <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={4}>
                    <Typography variant="body2" textAlign="center" mb={6} sx={{ fontSize: '1rem' }}>
                        Though we’re just getting started, this space will soon be full of energy, inspiration, and action.
                    </Typography>
                </motion.div>
            </Box>
            <Container maxWidth="xl">
                <Grid container spacing={4} sx={{ pb: 6 }}>
                    {newsData.map((item, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <motion.div
                                variants={fadeUp}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                custom={index + 1}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        borderRadius: 3,
                                        overflow: 'hidden',
                                        bgcolor: COLORS.white,
                                        boxShadow: 1,
                                        height: '100%',
                                    }}
                                >
                                    <Box
                                        component="div"
                                        sx={{
                                            flex: { xs: 'none', sm: 1.4 },
                                            width: '100%',
                                            height: { xs: 200, md: 410 },
                                            backgroundImage: `url(${item.image})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            flex: 1,
                                            px: { xs: 2, md: 4 },
                                            py: { xs: 3, md: 4 },
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Typography variant="h5" mb={1}>{item.date}</Typography>
                                        <Typography
                                            variant="h6"
                                            component={Link}
                                            href={item.link}
                                            underline="none"
                                            mb={2}
                                            sx={{ color: COLORS.pureBlack, mt: 2 }}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography variant="body2" mb={2}>{item.Description}</Typography>
                                        <Box sx={{ flexGrow: 1 }} />
                                        <Box sx={{ mt: 2, width: { xs: '100%', md: 'auto' } }}>
                                            <CustomTextButton label="Read More" href="/about" />
                                        </Box>
                                    </Box>
                                </Box>
                            </motion.div>
                        </Grid>
                    ))}
                </Grid>
            </Container>
            <JoinCommunity />
        </>
    );
};

export default ChampionsForgeSection;
